/**
 * Normalizes indexer/API `stash_funded` to a UI number: 0 = underfunded (show pill), 1 = funded.
 * Missing or unknown values default to funded (1).
 */
export function normalizeStashFundedForUi(value: unknown): 0 | 1 {
  if (value === false || value === 0) return 0;
  if (value === true || value === 1) return 1;
  if (typeof value === 'string') {
    const t = value.trim().toLowerCase();
    if (t === '0' || t === 'false') return 0;
    if (t === '1' || t === 'true') return 1;
  }
  return 1;
}
